import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type Parameter = {
    downloadtearsheet: boolean;
};

export const DispatchSetTearsheetDownloadLoading: CustomApiHandler<Parameter, boolean> = props => {
    props.dispatch({
        type: "Custom/ProductList/SetTearsheetDownloadLoading",
        result: props.parameter.downloadtearsheet,
    });
};

export const chain = [DispatchSetTearsheetDownloadLoading];

const setTearsheetDownloadLoading = createHandlerChainRunner(chain, "SetTearsheetDownloadLoading");
export default setTearsheetDownloadLoading;